import React from 'react'
import PropTypes from 'prop-types'

const ImportTabIcon = (props) => {
  const { color = '#FFFFFF', classes = 'w-20' } = props
  return (
    <svg
      width="34"
      height="34"
      viewBox="0 0 34 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_5195_55634"
        maskUnits="userSpaceOnUse"
        x="7"
        y="8"
        width="19"
        height="19"
        className={classes}
      >
        <rect
          x="7.97656"
          y="8.53149"
          width="17.68"
          height="17.68"
          fill="#D9D9D9"
        />
      </mask>
      <g mask="url(#mask0_5195_55634)">
        <path
          d="M13.1334 21.0548H18.2901V19.5815H13.1334V21.0548ZM13.1334 18.1081H20.5001V16.6348H13.1334V18.1081ZM13.1334 15.1615H20.5001V13.6881H13.1334V15.1615ZM11.6601 24.0015C11.2549 24.0015 10.9081 23.8572 10.6196 23.5687C10.331 23.2801 10.1868 22.9333 10.1868 22.5281V12.2148C10.1868 11.8096 10.331 11.4628 10.6196 11.1742C10.9081 10.8857 11.2549 10.7415 11.6601 10.7415H21.9734C22.3786 10.7415 22.7254 10.8857 23.014 11.1742C23.3025 11.4628 23.4468 11.8096 23.4468 12.2148V22.5281C23.4468 22.9333 23.3025 23.2801 23.014 23.5687C22.7254 23.8572 22.3786 24.0015 21.9734 24.0015H11.6601ZM11.6601 22.5281H21.9734V12.2148H11.6601V22.5281Z"
          fill={color}
        />
      </g>
      <circle cx="17" cy="17" r="16.66" stroke={color} strokeWidth="0.68" />
    </svg>
  )
}

ImportTabIcon.propTypes = {
  color: PropTypes.string,
  classes: PropTypes.string,
}

export default React.memo(ImportTabIcon)
